const isFakeEmail = (email: string) => {
  return (
    email !== undefined &&
    email !== null &&
    email.trim().match(/^.*\.temp[0-9]*$/)
  )
}

export default isFakeEmail
